module.exports = __webpack_public_path__ + "img/coppa.71963296.png";